export default __webpack_public_path__ + "static/media/reaction-correct.b8693f86.svg";